<div class="invoice__detail-info">
  <div class="info-row invoice__row">
    <div class="info-row__left">
      <div class="info-row__col">
        <div class="info-cell info-row__cell">
          <div class="info-cell__label">Тип</div>
          <div class="info-cell__content">
            {{ invoiceFullData?.cargoType?.description || invoiceFullData.CargoType || '&mdash;' }}
          </div>
        </div>
        <div class="info-cell info-row__cell">
          <div class="info-cell__label">Вага</div>
          <div *ngIf="invoiceFullData?.CalculatedWeight > 0 && !!invoiceFullData?.CheckWeightMethod && invoiceFullData?.CheckWeightMethod !== 'Volumetric';
           else weight" class="info-cell__content">
            <span
              class="line-through-text">{{ invoiceFullData?.FactualWeight }}</span> {{ (invoiceFullData?.CalculatedWeight) + ' кг' }}
          </div>
          <ng-template #weight>
            <div class="info-cell__content" *ngIf="invoiceFullData?.FactualWeight; else dash">
              {{ (invoiceFullData?.FactualWeight) + ' кг' }}
            </div>
          </ng-template>
        </div>
      </div>
      <div class="info-row__col">
        <div class="info-cell info-row__cell">
          <div class="info-cell__label">Об’ємна вага</div>
          <div *ngIf="invoiceFullData?.CalculatedWeight > 0 && !!invoiceFullData?.CheckWeightMethod && invoiceFullData?.CheckWeightMethod === 'Volumetric';
           else volume" class="info-cell__content">
            <span
              class="line-through-text">{{ invoiceFullData?.volumeWeight || invoiceFullData?.VolumetricWeight }}</span> {{ (invoiceFullData?.CalculatedWeight) + ' кг' }}
          </div>
          <ng-template #volume>
            <div class="info-cell__content"
                 *ngIf="invoiceFullData?.volumeWeight || invoiceFullData?.VolumetricWeight; else dash">
              {{ (invoiceFullData?.volumeWeight || invoiceFullData?.VolumetricWeight) + ' кг' }}
            </div>
          </ng-template>
        </div>
        <div class="info-cell info-row__cell">
          <div class="info-cell__label">Місць</div>
          <div class="info-cell__content">
            {{ (invoiceFullData?.seatsAmount || invoiceFullData?.SeatsAmount) || '&mdash;' }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="info-row invoice__row">
    <div class="info-row__left">
      <div class="info-cell info-row__cell">
        <div class="info-cell__label">Внутрішній номер відправлення</div>
        <div class="info-cell__content">
          <span class="copy-content d-inline-block"
                *ngIf="invoiceFullData?.clientBarcode && invoiceFullData?.clientBarcode.length > 0 ||
                       invoiceFullData.ClientBarcodes && invoiceFullData.ClientBarcodes?.length > 0">
                {{ (invoiceFullData?.clientBarcode || invoiceFullData.ClientBarcodes) }}
            <button mat-icon-button class="copy-content__btn"
                    [appPhoneCopy]="invoiceFullData?.clientBarcode || invoiceFullData.ClientBarcodes"
                    [matTooltip]="'Скопіювати'" matTooltipPosition="below">
                      <mat-icon class="material-icons_grey copy-content__icon">content_copy</mat-icon>
            </button>
          </span>
          <span *ngIf="!invoiceFullData?.clientBarcode || !invoiceFullData?.clientBarcode.length &&
                       !invoiceFullData?.ClientBarcodes">&mdash;</span>
        </div>
      </div>
    </div>
    <div class="info-row__right">
      <div class="info-cell info-row__cell info-row__cell-overflow info-row__max-width-fit-content">
        <div class="info-cell__label">Додаткова інформація про відправлення</div>
        <div class="info-cell__content">
          {{ (invoiceFullData?.note) || (invoiceFullData?.Note) || invoiceFullData.AdditionalInformationEW || '&mdash;' }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #dash>—</ng-template>
